/* eslint-disable */
import {isCmsPath} from '@shared/_helpers'
import {UPDATE_WINDOW_WIDTH} from "./mutation-types";

let breakpoints = {
    sm: 640,
    md: 1024,
    lg: 1200,
    xl: 1460,
    xxl: Infinity,
};

const state = {
    windowWidth: window.innerWidth,
};

const actions = {
    updateWindowWidth({commit}) {
        commit(UPDATE_WINDOW_WIDTH);
    }
};

const mutations = {
    [UPDATE_WINDOW_WIDTH](state) {
        state.windowWidth = window.innerWidth;
    }
};

const getters = {
    isDesktop(state) {
        return state.windowWidth > breakpoints['md'];
    },
    isMobile(state) {
        return state.windowWidth <= breakpoints['md'];
    }
};

export const media = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};